export const LOGIN_ROUTE = '/login';
export const SIGNUP_ROUTE = '/signup';
export const ROOT_REDIRECT_ROUTE = '/narratives';
